// @flow
import { execute }        from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import closeEsp from 'fg-frontend/webActions/closeEsp';
import goBackPeople from './webActions/goBackPeople';
import goBack           from './webActions/goBack';
import scrollToHref from 'fg-frontend/webActions/scrollToHref';
import confirmPopup from 'fg-frontend/webActions/confirmPopup';
import passwordStrength from 'fg-frontend/webActions/passwordStrength';
import contentAccordionToggle from './webActions/contentAccordionToggle';
import menuToggle from './webActions/menuToggle';
import dropdownHandler from './webActions/dropdownHandler';
import headerNavDropdownHandler from './webActions/headerNavDropdownHandler';
import headerNavDropdownClose from './webActions/headerNavDropdownClose';
import toTop from './webActions/toTop';
import replaceHistory from 'fg-frontend/webActions/replaceHistory';
import toggleClass from 'fg-frontend/webActions/toggleClass';
import printPage from 'fg-frontend/webActions/printPage';

import configureEshopActions from './configureEshopActions';

export default (action) => {
	switch (action) {
		case 'hsExpand':
			return (props, e) => {
				e.preventDefault();
				CursorSpinner.pushToQueue('importHsExpand');
				import('./webActions/hsExpand').then((hsExpand) => {
					CursorSpinner.removeFromQueue('importHsExpand');
					hsExpand.default(props, e);
				});
			};
		case 'execute':
			return execute;
		case 'closeEsp':
			return closeEsp;
		case 'goBack':
			return goBack;
		case 'goBackPeople':
			return goBackPeople;
		case 'scrollToHref':
			return scrollToHref;
		case 'passwordStrength':
			return passwordStrength;
		case 'confirmPopup':
			return confirmPopup;
		case 'menuToggle':
			return menuToggle;
		case 'dropdownHandler':
			return dropdownHandler;
		case 'headerNavDropdownHandler':
			return headerNavDropdownHandler;
		case 'headerNavDropdownClose':
			return headerNavDropdownClose;
		case 'toTop':
			return toTop;
		case 'replaceHistory':
			return replaceHistory;
		case 'contentAccordionToggle':
     		return contentAccordionToggle;
		case 'toggleClass':
			return toggleClass;
    case 'printPage':
      return printPage;
		default:
			const eshopAction = configureEshopActions(action);
			if (eshopAction) {
				return eshopAction;
			}
			else {
				console.log(`Unknown action`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js